import getHelper from '../../../services/getHelper';
import { Language } from '../types';

export default getHelper<Language[]>('/languages');
